import { MdOutlineLocationOn } from 'react-icons/md';

export default function ItemLocation({ location }: { location: string }) {
  if (!location) return false;

  return (
    <div className='flex gap-2'>
      <span className='text-2xl'>
        <MdOutlineLocationOn />
      </span>
      <span className='font-semibold'>{location}</span>
    </div>
  );
}
